/**
 * Resolves label text on SELECT nodes for certain tagging projects.
 *
 * @param element SELECT element containing the text.
 * @returns string label text.
 */

const getLinkLabel = (element) => {
	let label = '';
	if (element && element.nodeName === 'SELECT') {
		if ($(element).siblings('label').length > 0) {
			label = $(element).siblings('label').text();
		} else {
			label = $(element).find('option:first-child').text();
		}
	}
	return label;
};

export default getLinkLabel;
